import { bl_cms_website_exts_RowClass } from '../../../dbschema/bl_cms_website_exts.model';
import { bl_cms_website_hdr_RowClass } from '../../../dbschema/bl_cms_website_hdr.model';
import { bl_cms_website_lines_RowClass } from '../../../dbschema/bl_cms_website_lines.model';
import {BaseContainerModel} from '../../base-container.model';

export class WebsiteContainerModel extends BaseContainerModel {
  bl_cms_website_hdr: bl_cms_website_hdr_RowClass = new bl_cms_website_hdr_RowClass();
  bl_cms_website_exts: bl_cms_website_exts_RowClass[] = [];
  bl_cms_website_lines: bl_cms_website_lines_RowClass[] = [];

}
